import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=21c73999"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=21c73999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports